import styled from '@emotion/styled'

const UserToPickPlaceholder = styled.div`
	width: 100%;
	height: 100%;
`

export default UserToPickPlaceholder
